import { FormBase } from '../form';
import { AsdBase } from '../../asd/asd';
import { GridRow } from '../../grid/grid';
import { InterfaceElement } from '../../asd/asd-properties/asd-ie/asd-interfaceElement';
import { ViewArea } from '../../asd/asd-properties/asd-viewArea';
import { Header } from '../../asd/asd-properties/asd-header';

export class FormInit {
  Header: Header;
  UXControllerProperties: FormBase;
  InterfaceFormElementList: InterfaceElement[];
  ViewAreaList: ViewArea[];
  GridRows: GridRow[];
  DesignDocument: AsdBase;
  CustomAppStateDocument: AsdBase;
  TemplateAppStateDocument: AsdBase;
}
